import { EVAL_CRITERION } from "@shared/models";

/** Criteria every category is scored for — the ones worth showing in the list. */
export const TOP_EVAL_CRITERIA = [EVAL_CRITERION.CONCISENESS, EVAL_CRITERION.RELEVANCY, EVAL_CRITERION.HARMFULNESS];

/** The order criteria are shown in, matching the eval engine's own order. */
export const EVAL_CRITERIA_ORDER = Object.values(EVAL_CRITERION);

export const EVAL_CSV_MAX_FILE_SIZE = 5 * 1024 * 1024;

/** Columns the runner reads. The rest of the template's columns are for reviewers. */
export const EVAL_CSV_REQUIRED_COLUMNS = ["category", "inputQuery"];

export const EVAL_TEMPLATE_FILE_NAME = "eval-template.csv";

export const MAX_SCORE = 5;

export const EVAL_RUN_POLL_INTERVAL = 10000; // 10 sec
